import { Box, Typography } from '@mui/material'
import { spacing } from 'c1ui/theme/C1Spacing'
import { RendererProps, resolveDynamicString } from 'components/a2ui/types'
import { DynamicEditor } from 'components/core/editor/editor'
import { getByPointer } from 'lib/a2ui/resolver'
import { FC } from 'react'

type C1CodeBlockRendererProps = Pick<RendererProps, 'component' | 'dataModel'>

/**
 * Renders a code block with syntax highlighting using the DynamicEditor component.
 */
export const C1CodeBlockRenderer: FC<C1CodeBlockRendererProps> = ({ component, dataModel }) => {
    if (component.component.oneofKind !== 'c1CodeBlock') return null

    const cb = component.component.c1CodeBlock
    const code = resolveDynamicString(cb.code, dataModel, getByPointer)
    const title = resolveDynamicString(cb.title, dataModel, getByPointer)
    const language = resolveDynamicString(cb.language, dataModel, getByPointer) || 'cel'

    return (
        <Box>
            {title && <Typography variant="subtitle2" mb={spacing.xs}>{title}</Typography>}
            <DynamicEditor
                value={code}
                language={language}
                options={{ readOnly: true }}
                showVariableBrowser={false}
                enableFetchValidation={false}
                minHeight="40px"
                maxHeight="300px"
            />
        </Box>
    )
}
